import { css } from 'styled-system/css';


// Grid (parent) container style
export const gestureUnlockStyle = {
	gridStyle: css({
		position: 'relative',
		width: '210px',
		height: '210px',
	}),
	svgLine: css({
		position: 'absolute',
		top: '0',
		left: '0',
		pointerEvents: 'none', // Allow clicking through the SVG
		transition: 'stroke 0.3s ease-in-out',
		stroke: 'jupiter.black.12',
		overflow: 'visible',
		'&.warning': {
			stroke: 'jupiter.error.50',
		},
		'&.success': {
			stroke: 'jupiter.success.50',
		},
	}),
	circleStroke: css({
		base: {
			stroke: 'jupiter.grey.40',
			transition: 'stroke 0.3s ease-in-out',
			'&.active': {
				stroke: 'jupiter.grey.50',

				'&.success': {
					stroke: 'jupiter.success.70',
					fill: 'jupiter.success.12',		
				},

				'&.warning': {
					stroke: 'jupiter.error.70',
					fill: 'jupiter.error.12',
				}

			},

			
		}
	}),
	circleDot: css({
		base: {
			fill: 'jupiter.grey.50',
			transition: 'fill 0.3s ease-in-out',
			'&.active': {
				fill: 'jupiter.grey.60',

				'&.success': {
					fill: 'jupiter.success.50'				
				},

				'&.warning': {
					fill: 'jupiter.error.50',
				}
			},
		}
	})
};
